import Chartist from 'chartist';

export default function chartistLabelsPlugin(options){
  return function(chart){
    chart.on('draw',(data) => {
      if(data.type === 'bar'){
        data.element.attr({id:`${options.idPrefix}_${data.value.y}`})
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/routes/DabblAudience/chartistLabelsPlugin.js